import m from "../../../../geodata/es2015/region/world/southAmericaLow";
window.am4geodata_region_world_southAmericaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/southAmericaLow.js
// module id = null
// module chunks = 